import { render, staticRenderFns } from "./ReportingForm.vue?vue&type=template&id=131e97d6"
import script from "./ReportingForm.vue?vue&type=script&lang=js"
export * from "./ReportingForm.vue?vue&type=script&lang=js"
import style0 from "./ReportingForm.vue?vue&type=style&index=0&id=131e97d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports